import React, { createContext, useContext, useState, useEffect } from 'react';
import { getCountryById } from '../lib/countrySettings';

const CurrencyContext = createContext();

export const CURRENCIES = [
  { code: 'EUR', symbol: '€', label: 'Euro (€)' },
  { code: 'USD', symbol: '$', label: 'US Dollar ($)' },
  { code: 'GBP', symbol: '£', label: 'British Pound (£)' },
];

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState(() => {
    const selectedCountryId = localStorage.getItem('selectedCountry') || 'ie';
    const selectedCountry = getCountryById(selectedCountryId);
    const symbolMap = { EUR: '€', USD: '$', GBP: '£' };
    const symbol = symbolMap[selectedCountry.currency] || selectedCountry.currencySymbol || selectedCountry.currency;
    return {
      code: selectedCountry.currency,
      symbol,
      label: `${selectedCountry.name} (${symbol})`,
    };
  });

  useEffect(() => {
    const handleCountryChange = () => {
      const selectedCountryId = localStorage.getItem('selectedCountry') || 'ie';
      const selectedCountry = getCountryById(selectedCountryId);
      const symbolMap = { EUR: '€', USD: '$', GBP: '£' };
      const symbol = symbolMap[selectedCountry.currency] || selectedCountry.currencySymbol || selectedCountry.currency;
      setCurrency({
        code: selectedCountry.currency,
        symbol,
        label: `${selectedCountry.name} (${symbol})`,
      });
    };
    window.addEventListener('countryChanged', handleCountryChange);
    return () => window.removeEventListener('countryChanged', handleCountryChange);
  }, []);

  useEffect(() => {
    document.documentElement.dataset.currencySymbol = currency.symbol;
    document.documentElement.dataset.currencyCode = currency.code;
  }, [currency]);

  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined || isNaN(amount)) return `${currency.symbol}0.00`;
    return `${currency.symbol}${parseFloat(amount).toFixed(2)}`;
  };

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, formatCurrency, CURRENCIES }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);

